import { render, staticRenderFns } from "./editvideo.vue?vue&type=template&id=0af68f46&scoped=true"
import script from "./editvideo.vue?vue&type=script&lang=js"
export * from "./editvideo.vue?vue&type=script&lang=js"
import style0 from "./editvideo.vue?vue&type=style&index=0&id=0af68f46&prod&scoped=true&lang=css"
import style1 from "./editvideo.vue?vue&type=style&index=1&id=0af68f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af68f46",
  null
  
)

export default component.exports